<template>
  <div class="todo-group">
    <div v-if="todoGroup.length > 1">
      <TodoItem :todo="first(todoGroup)" data-test="todo-item" />
      <div v-if="expanded">
        <div v-for="(todo, index) in todoGroup" :key="todo.id">
          <TodoItem :todo="todo" data-test="todo-item" v-if="index" />
        </div>
      </div>
      <div @click="expanded = !expanded" class="trigger">
        <div class="icon-wrapper">
          <v-icon>
            {{ `mdi-chevron-${expanded ? "up" : "down"}` }}
          </v-icon>
        </div>
        <div class="title">
          {{ triggerTitle }}
        </div>
      </div>
    </div>
    <div v-else v-for="todo in todoGroup" :key="todo.id">
      <TodoItem :todo="todo" data-test="todo-item" />
    </div>
  </div>
</template>

<script>
import TodoItem from "@/components/todos/TodoItem";
import { first, size } from "lodash";

export default {
  props: {
    todoGroup: Array
  },
  computed: {
    groupCount() {
      return size(this.todoGroup);
    },
    triggerTitle() {
      return this.expanded ? "Show less" : `${this.groupCount - 1} more...`;
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  components: {
    TodoItem
  },
  methods: {
    first
  }
};
</script>

<style lang="scss">
.todo-group {
  .trigger {
    cursor: pointer;
    width: fit-content;
    display: flex;
    align-items: center;
    margin-top: -10px;

    @media only screen and (min-width: $mobile-breakpoint) {
      margin-left: 84px;
    }

    .title {
      margin-left: 5px;
      font-weight: bold;
      font-size: 18px !important;
      color: $primary-action-text;
    }

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      background: #f7f7f7;
      border-radius: 4px;
    }
  }
}
</style>
